// This file is generated by next-core EcmascriptClientReferenceModule.
import { registerClientReference } from "react-server-dom-turbopack/server";
export const OrderDetailClient = registerClientReference(
    function() { throw new Error("Attempted to call OrderDetailClient() from the server but OrderDetailClient is on the client. It's not possible to invoke a client function from the server, it can only be rendered as a Component or passed to props of a Client Component."); },
    "[project]/web/src/app/(admin)/admin/orders/[id]/order-detail-client.tsx",
    "OrderDetailClient",
);
